<template>
  <Layout>
    <div class="product-info">
      <AppSlideshow />
    </div>
  </Layout>
</template>

<script>
import Layout from '@/router/layouts/Main'
import AppSlideshow from '@/components/products/slideshow/Slideshow.vue'

export default {
  components: {
    Layout,
    AppSlideshow,
  },
}
</script>
